export const DATE_PRESETS = [
  { value: "today", label: "Hôm nay", days: 0 },
  { value: "7d", label: "7 ngày", days: 7 },
  { value: "30d", label: "30 ngày", days: 30 },
  { value: "all", label: "Tất cả", days: null },
];

export const computeDateRange = (preset, custom) => {
  if (preset === "custom")
    return custom || { dateFrom: undefined, dateTo: undefined };
  const found = DATE_PRESETS.find((p) => p.value === preset);
  if (!found || found.days === null)
    return { dateFrom: undefined, dateTo: undefined };
  const now = new Date();
  if (found.days === 0) {
    const start = new Date(now);
    start.setHours(0, 0, 0, 0);
    return { dateFrom: start.toISOString(), dateTo: undefined };
  }
  const start = new Date(now);
  start.setDate(start.getDate() - found.days);
  return { dateFrom: start.toISOString(), dateTo: undefined };
};
